@if (responseData.length) {
    <p-table styleClass="p-datatable-sm p-datatable-sm--normal" [value]="responseData" dataKey="_id"
        [tableStyle]="{ 'min-width': '60rem' }" [expandedRowKeys]="expandedRows" (onRowExpand)="onRowExpand($event)"
        (onRowCollapse)="onRowCollapse($event)" autoLayout="true" [scrollable]="true">
        <ng-template pTemplate="header">
            <tr>
                <th>
                    Role

                </th>
                <th>
                    Position

                </th>
                <th>
                    {{'Last Offer Sent' | sentenceCase}}

                </th>
                <th>
                    {{'Offer Sent' | sentenceCase}}
                </th>
                @if (helperService.checkResponsive()) {
                    <th style="width: 8%" alignFrozen="right" pFrozenColumn>
                      <ng-container *ngTemplateOutlet="frozenHeader"></ng-container>
                    </th>
                    } @else {
                    <th style="width: 8%">
                      <ng-container *ngTemplateOutlet="frozenHeader"></ng-container>
                    </th>
                }
                <ng-template #frozenHeader>
                Action
                </ng-template>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" class="border-0" let-responseData let-expanded="expanded">
            <tr>
                <td>{{ responseData.roleType }}</td>
                <td> {{ responseData.positions }} listed / {{ responseData.positionsFilled }} filled 
                    @if(responseData.presumptivelyPendingOfferCount){
                        / {{ responseData.presumptivelyPendingOfferCount }} pending
                    }
                </td>
                <td>
                    @if (responseData.lastOfferSent) {
                    {{responseData.lastOfferSent | date:'h:mma MM/dd/yyyy ' }}
                    } @else {
                    -
                    }
                </td>
                <td>{{ responseData.offersCount ? responseData.offersCount : 'No offers sent' }}</td>
                @if (helperService.checkResponsive()) {
                    <td alignFrozen="right" pFrozenColumn>
                      <ng-container *ngTemplateOutlet="frozenData"></ng-container>
                    </td>
                    } @else {
                    <td>
                      <ng-container *ngTemplateOutlet="frozenData"></ng-container>
                    </td>
                    } 
                    <ng-template #frozenData>
                        <div class="flex gap-2">
        
                            @if(!responseData.isArchived){
                                <div [pTooltip]="getCancelButtonTooltip(responseData) | sentenceCase" tooltipPosition="top">
                                    <button [disabled]="responseData.disableCancelOfferButton" pButton pRipple type="button" (click)="cancelAllOutstandingOffer($event, responseData)"
                                        class="p-button-rounded p-button-text">
                                        <span class="{{helperService.getEnvironmentName()}}-icon icon-cancel-outlined" [ngClass]="{'p-disabled': responseData.disableCancelOfferButton, 'red': !responseData.disableCancelOfferButton}"></span>
                                    </button>
                                </div>
                            }
        
                            @if(!responseData.isArchived && user.role === 'FIRM_MANAGER' && (responseData.offers.unViewed.length || responseData.offers.viewed.length || responseData.offers.rejected.length)){
                                <button pTooltip="Download" (click)="downloadCSV(responseData.offers, responseData.roleType)" tooltipPosition="top" pButton pRipple type="button"
                                    class="p-button-rounded p-button-text">
                                    <span class="{{helperService.getEnvironmentName()}}-icon icon-download-outlined"></span>
                                </button>
                            }
                            @if(responseData.status === roleStatus.archive){
                                <div>
                                    <span class="tag-value {{ 'ARCHIVE' | lowercase }}">
                                        Ended
                                    </span>
                                </div>
                            }
        
                            <p-button [pTooltip]="expanded? 'Close' : 'Expand'" tooltipPosition="top" type="button" pRipple
                                [pRowToggler]="responseData" [text]="true" [rounded]="true" [plain]="true" [icon]="
                        expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-up'
                    " class="row-toggler toggler-btn" />
                        </div>
                    </ng-template>
            </tr>
        </ng-template>
        <ng-template pTemplate="rowexpansion" let-responseData>
            <tr>
                <td colspan="7" class="p-0">
                    <div class="p-0 inner-wrap surface-100">
                        <p-table [value]="responseData.offerList" dataKey="_id">
                            <ng-template pTemplate="header">
            <tr>
                <th class="pl-40" style="width: 25%;">
                    Unviewed <span class="count">{{responseData.offers.unViewed.length}}</span>
                </th>
                <th style="width: 25%;">
                    Viewed <span class="count">{{responseData.offers.viewed.length}}</span>
                </th>
                <th style="width: 25%;">
                    {{'Late Accept' | sentenceCase}} <span class="count">{{responseData.lateOfferAcceptedReviewers.length}}</span>
                </th>
                <th style="width: 25%;">
                    Rejected <span class="count">{{responseData.offers.rejected.length}}</span>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-offerList>

            <tr class="expandedItem">
                <td class="pr-40 pt-3">
                    @for (uv of offerList.unViewed; track uv) {
                            <div class="flex flex-wrap gap-2 row-height">
                                <span class="cursor-pointer" (click)="openReviewerDialog(uv.reviewer._id)">
                                    {{uv.reviewer.firstName}} {{uv.reviewer.lastName}}
                                </span>
                                @if(responseData.status !== roleStatus.archive && uv.status !== 'UNAVAILABLE'){
                                    <span [pTooltip]="'Cancel Offer' | sentenceCase" tooltipPosition="top">
                                        <button pButton pRipple type="button" (click)="cancelOffer($event, uv)"
                                            class="p-button-rounded p-button-text p-0">
                                            <span class="{{helperService.getEnvironmentName()}}-icon icon-cancel-outlined red"></span>
                                        </button>
                                    </span>
                                }
                                @if(uv.status === 'UNAVAILABLE'){

                                    <span [pTooltip]="'Offer No Longer Available' | sentenceCase" tooltipPosition="top">
                                        <button pButton pRipple type="button"
                                            class="p-button-rounded p-button-text p-0">
                                            <span class="{{helperService.getEnvironmentName()}}-icon icon-info-outlined"></span>
                                        </button>
                                    </span>
                                }
                            </div>
                        }
                </td>
                <td class="pr-40 pt-3">
                    @for (view of offerList.viewed; track view) {
                            <div class="flex flex-wrap gap-2 row-height">
                                <span class="cursor-pointer" (click)="openReviewerDialog(view.reviewer._id)">
                                    {{view.reviewer.firstName}} {{view.reviewer.lastName}}
                                </span>
                                @if(responseData.status !== roleStatus.archive && view.status !== 'UNAVAILABLE'){
                                    <span [pTooltip]="'Cancel Offer' | sentenceCase" tooltipPosition="top">
                                        <button pButton pRipple type="button" (click)="cancelOffer($event, view)"
                                            class="p-button-rounded p-button-text p-0">
                                            <span class="{{helperService.getEnvironmentName()}}-icon icon-cancel-outlined red"></span>
                                        </button>
                                    </span>
                                }
                                @if(view.status === 'UNAVAILABLE'){

                                    <span [pTooltip]="'Offer No Longer Available' | sentenceCase" tooltipPosition="top">
                                        <button pButton pRipple type="button"
                                            class="p-button-rounded p-button-text p-0">
                                            <span class="{{helperService.getEnvironmentName()}}-icon icon-info-outlined"></span>
                                        </button>
                                    </span>
                                }
                            </div>
                        }
                </td>
                <td class="pr-40 pt-3">
                    @for (late of offerList.lateOfferAcceptedReviewers; track late) {
                            <div class="flex flex-wrap gap-2 row-height">
                                <span class="cursor-pointer" (click)="openReviewerDialog(late?.reviewer._id)">
                                    {{late?.reviewer?.firstName}} {{late?.reviewer?.lastName}}
                                </span>
                            </div>
                        }
                </td>
                <td class="pr-40 pt-3">
                    @for (reject of offerList.rejected; track reject) {
                            <div class="flex flex-wrap gap-2 row-height">
                                <span class="cursor-pointer" (click)="openReviewerDialog(reject.reviewer._id)">
                                    {{reject.reviewer.firstName}} {{reject.reviewer.lastName}}
                                </span>
                                <div>
                                    <span class="tag-value rejected-status" [pTooltip]="reject.status | sentenceCase" tooltipPosition="top">
                                        {{ reasonToShow(reject) | sentenceCase }}
                                    </span>
                                </div>
                            </div>
                    }
                    
                </td>
            </tr>
        </ng-template>
    </p-table>
    </div>
    </td>
    </tr>
        </ng-template>
    </p-table>
}

@else {
    <span class="text-sm font-medium">{{'No Roles Created' | sentenceCase}}</span>
}